import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { BsArchive, BsPencil, BsThreeDotsVertical, BsTrash, BsPlusSquare, BsDownload, BsClockHistory, BsSend, BsEye } from 'react-icons/bs';
import { SlMagnifier } from 'react-icons/sl';
import { GoChevronDown } from 'react-icons/go';

const TableActionButtons = ({
  row,
  rowClicks,
  embedded,
  is_archived,
  onNachuntersuchung,
  onHistory,
  parentId,
  apiEndpoint,
  onDelete,
  onArchive,
  onEdit,
  onExport,
  expandedRowId,
  handleRowClick,
  onEmailLogDetail,
  onEmailLogResend,
}) => {
  const endpoint = apiEndpoint ? apiEndpoint.split('/')[0] : '';
  const canEdit = global.auth.permissions[endpoint] && global.auth.permissions[endpoint].edit;
  const canView = global.auth.permissions[endpoint] && global.auth.permissions[endpoint].view;
  const canEditReport = global.auth.permissions["report"] && global.auth.permissions["report"]["edit"];
  const canViewReport = global.auth.permissions["report"] && global.auth.permissions["report"]["view"];

  if ((rowClicks && !embedded) || (rowClicks && !is_archived)) {
    return (
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleRowClick(e, row.id);
        }}
        className="btn btn-secondary tableActionButton"
      >
        <GoChevronDown className={expandedRowId === row.id ? 'rotated' : ''} />
      </button>
    );
  }

  if (is_archived) {
    return <></>;
  }

  if (embedded && onNachuntersuchung) {
    return (
      <UncontrolledDropdown className="tableAction">
        <DropdownToggle color="secondary" className="tableActionButton">
          <BsThreeDotsVertical />
        </DropdownToggle>
        <DropdownMenu>
          {canEditReport ? (
            <>
              <DropdownItem disabled={row.id === null} onClick={onEdit.bind(null, row.id, "untersuchungen")}>
                <BsPencil /> <span>Untersuchung bearbeiten</span>
              </DropdownItem>
              <DropdownItem onClick={() => onNachuntersuchung(row, "untersuchungen")}>
                <BsPlusSquare /> <span>Nachuntersuchung erfassen</span>
              </DropdownItem>
              {onHistory && (
                <DropdownItem onClick={() => onHistory(parentId, row["firmenkartei.id"])}>
                  <BsClockHistory /> <span>Historie anzeigen</span>
                </DropdownItem>
              )}
            </>
          ) : canViewReport ? (
            <>
              <DropdownItem disabled={row.id === null} onClick={onEdit.bind(null, row.id, "untersuchungen")}>
                <SlMagnifier /> <span>Untersuchung Ansehen</span>
              </DropdownItem>
              {onHistory && (
                <DropdownItem onClick={() => onHistory(parentId, row["firmenkartei.id"])}>
                  <BsClockHistory /> <span>Historie anzeigen</span>
                </DropdownItem>
              )}
            </>
          ) : null}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  if (canEdit) {
    return (
      <UncontrolledDropdown className="tableAction">
        <DropdownToggle color="secondary" className="tableActionButton">
          <BsThreeDotsVertical />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => onEdit(row.id)}>
            <BsPencil /> <span>Bearbeiten</span>
          </DropdownItem>
          {onExport && (
            <DropdownItem onClick={() => onExport(row.id)}>
              <BsDownload /> Exportieren
            </DropdownItem>
          )}
          {onArchive && (
            <DropdownItem onClick={() => onArchive(row.id)}>
              <BsArchive /> Archivieren
            </DropdownItem>
          )}
          <DropdownItem divider />
          <DropdownItem className="deleteItem" onClick={() => onDelete(row.id)}>
            <BsTrash /> Löschen
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  if (canView) {
    return (
      <UncontrolledDropdown className="tableAction">
        <DropdownToggle color="secondary" className="tableActionButton">
          <BsThreeDotsVertical />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => onEdit(row.id)}>
            <SlMagnifier /> <span>Ansehen</span>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  // Spezielle Aktionen fuer den E-Mail-Verlauf
  if (apiEndpoint === "emailLog" && (onEmailLogDetail || onEmailLogResend)) {
    return (
      <UncontrolledDropdown className="tableAction">
        <DropdownToggle color="secondary" className="tableActionButton">
          <BsThreeDotsVertical />
        </DropdownToggle>
        <DropdownMenu>
          {onEmailLogDetail && (
            <DropdownItem onClick={() => onEmailLogDetail(row)}>
              <BsEye /> <span>Details</span>
            </DropdownItem>
          )}
          {onEmailLogResend && (
            <DropdownItem disabled={row.status === "queued"} onClick={() => onEmailLogResend(row)}>
              <BsSend /> <span>Erneut senden</span>
            </DropdownItem>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  return null;
};

export default TableActionButtons;
